import VideoElement from '../VideoElement/VideoElement';
import VideoElementPresets from '../VideoElement/VideoElementPresets';
import MobileVideoElementMetaData from './MobileVideoElementMetaData';
import MobileVideoElementProps from './MobileVideoElementProps';

export default {
  metaData: MobileVideoElementMetaData,
  elementClass: VideoElement.elementClass,
  elementProps: MobileVideoElementProps,
  presets: VideoElementPresets
};
